var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content"},[_vm._t("page-header",[(_vm.$slots.heading)?_c('PageHeader',[_vm._t("heading",null,{slot:"heading"}),_vm._t("tools",null,{slot:"tools"})],2):_vm._e()]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }